import jwtAuthAxios from "./auth/jwtAuth";

const tripServices = {};

tripServices.getTrips = async (params, xlsxFormat = false, signal) => {
    const url = xlsxFormat ? `/trips.xlsx${params}` : `/trips${params}`;

    const config = xlsxFormat
        ? {
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        }
        : {};

    if (signal) config.signal = signal;

    const { data } = await jwtAuthAxios.get(url, config);
    return data;
};

tripServices.getTripDetails = async (trip_id, params = "") => {
    const {data} = await jwtAuthAxios.get(`/trips/${trip_id}${params}`);
    return data;
};

tripServices.calculateRouteOrder = async (trip_id, params={}) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/calculate_route_order`, params);
    return data;
};

tripServices.calculateRoutes = async (body) => {
    const {data} = await jwtAuthAxios.post(`/trips/calculate_routes`, body);
    return data;
};

tripServices.updateTrip = async (trip_id, params, body) => {
    const {data} = await jwtAuthAxios.put(`/trips/${trip_id}${params}`, body);
    return data;
};

tripServices.assignPreparer = async (trip_id, params, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/assign_preparer${params ?? ""}`, body);
    return data;
};

tripServices.addByOrder = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/add_by_order`, body);
    return data;
};

// Agregar varios pedidos de una vez desde la lista con checkboxes del instructivo. El backend
// lo resuelve todo o nada: si rechaza alguno, no entra ninguno y contesta 422 con `rejected`.
tripServices.addByOrders = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/add_by_orders`, body);
    return data;
};

tripServices.addByCustomer = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/add_by_customer`, body);
    return data;
};

tripServices.addByPlace = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/add_by_place`, body);
    return data;
};

// Asigna o quita el dropoff de varios pedidos del viaje de una vez. El backend
// lo resuelve en una transaccion: o quedan todos o no queda ninguno.
tripServices.setOrdersDropoff = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/set_orders_dropoff`, body);
    return data;
}

tripServices.removeDelivery = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/remove_delivery`, body);
    return data;
}

// Saca varias entregas del viaje de una vez. Va en una sola llamada a proposito:
// encadenar removeDelivery se rompe cuando la penultima deja el viaje vacio, porque
// el backend borra el viaje solo y las que faltan responden 404.
tripServices.removeDeliveries = async (trip_id, body) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/remove_deliveries`, body);
    return data;
}

tripServices.deleteTrip = async (trip_id) => {
    const {data} = await jwtAuthAxios.delete(`/trips/${trip_id}`);
    return data;
}

// KPI de la cabecera: el día de hoy y el mes contra el mismo tramo del anterior.
tripServices.getKpis = async (date) => {
    const query = date ? `?date=${date}` : "";
    const { data } = await jwtAuthAxios.get(`/trips/kpis${query}`);
    return data;
};

// Plan Distribuidor: cierra el viaje y deja entregadas sus paradas abiertas.
tripServices.manualClose = async (tripId) => {
    const { data } = await jwtAuthAxios.post(`/trips/${tripId}/manual_close`);
    return data;
};

export default tripServices;
